import { currency } from 'vue2-filters/src/other'

export const cur = (val) => {
  const symbol = localStorage.getItem('currency')
  return currency(val, symbol, 2, {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true,
    thousandsSeparator: ' '
  })
}
